import { $get } from 'dashboard-js/helpers'
import { Debugger, log, warn } from 'dashboard-js/providers/DebuggingProvider'
import Turbolinks from 'turbolinks'

let currentTab = null
let currentVisit = {}
let currentVisitTime = null
let pendingRestorationDataSave = null
let restoreTab = false

export default class {
    static start() {
        if (Debugger.enabled()) {
            this.debug()
        }

        Turbolinks.start()

        // Patches an iOS Turbolinks bug.
        // When starting a visit cycle we snapshot the current scroll position
        // only to commit it when the next view has rendered
        // - unless the visit itself is a restoration visit
        window.addEventListener('turbolinks:click', () => {
            let restorationData = Turbolinks.controller.getCurrentRestorationData()
            let scrollPosition = {
                x: window.pageXOffset,
                y: window.pageYOffset,
            }

            log('Persisting scroll', scrollPosition)

            pendingRestorationDataSave = () => (restorationData.scrollPosition = scrollPosition)
        })

        window.addEventListener('turbolinks:visit', event => {
            currentVisit = event.data
            currentVisitTime = moment()
        })

        window.addEventListener('turbolinks:render', () => {
            if (pendingRestorationDataSave && !this.isRestored()) {
                pendingRestorationDataSave()
            }
            pendingRestorationDataSave = null
        })
    }

    static handle(event) {
        Turbolinks.controller.clickBubbled(event)
        event.preventDefault()
    }

    static go(url) {
        Turbolinks.visit(url)
    }

    static isRestored() {
        return $get(currentVisit, 'action', 'advance') === 'restore'
    }

    static justRestored() {
        if (this.isRestored()) {
            return moment().diff(currentVisitTime, 'milliseconds') < 1000
        }
        return false
    }

    static reload() {
        // Carry the current tab to reloaded page
        restoreTab = true

        this.go()

        document.addEventListener('turbolinks:visit', function teardown() {
            document.removeEventListener('turbolinks:visit', teardown)
            restoreTab = false
        })
    }

    static registerTab(name) {
        currentTab = name
    }

    static restoreScroll() {
        const uId = Turbolinks.controller.restorationIdentifier
        const pos = $get(Turbolinks.controller.getCurrentRestorationData(), 'scrollPosition', null)

        log('Restoring scroll', { uId, pos: pos })

        if (pos) {
            window.scrollTo(pos.x, pos.y)
        }
    }

    static requestedTab() {
        return restoreTab ? currentTab : null
    }

    static debug() {
        const events = [
            'turbolinks:click',
            'turbolinks:before-visit',
            'turbolinks:visit',
            'turbolinks:request-start',
            'turbolinks:request-end',
            'turbolinks:before-cache',
            'turbolinks:before-render',
            'turbolinks:render',
            'turbolinks:load',
        ]

        events.forEach(event => {
            window.addEventListener(event, payload => {
                warn(event, Turbolinks.controller.restorationIdentifier, payload)
            })
        })
    }
}
